/**
 * Created by Alex Aguilar on 5/10/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('seatsController', seatsController)
        .controller('newEditSeatController', newEditSeatController)
        .controller('deleteSeatController', deleteSeatController);

    seatsController.$inject = ['tabs', 'seats', 'linkService'];
    newEditSeatController.$inject = ['tabs', 'action', 'seat', 'categories', 'uploadService', 'seatModelAircraftService'];
    deleteSeatController.$inject = ['seat', 'seatModelAircraftService', '$uibModalInstance'];

    function seatsController(tabs, seats, linkService){
        var vm = this;
        vm.tabs = tabs;
        vm.pages = [];
        vm.linkService = linkService;
        vm.seats = (seats.data._embedded) ? seats.data._embedded.seatModelAircrafts: [];
        vm.pages = seats.data.page;
    }

    function newEditSeatController(tabs, action, seat, categories, uploadService, seatModelAircraftService){
        var vm = this;
        vm.tabs = tabs;
        vm.action = action;
        vm.seat = (vm.action == 'new') ? {} : seat.data;
        vm.old = angular.copy(vm.seat);
        vm.buttonSave = true;
        if(vm.action=='new'){
            vm.buttonSave = false;
        }
        vm.removeImage = (vm.action == 'new') ? false : true;
        vm.categories = (categories.data._embedded) ? categories.data._embedded.categories: [];
        vm.deleteImageSeat = function(){
            vm.removeImage = false;
        }

        vm.saveSeatModelAircraft = function(isValid, seat){
            if(isValid){
                if(vm.action === 'new'){
                    vm.seat.active = true;
                    vm.seat.hasPlug= false;

                    uploadService.uploadImage(seat.url, vm.seat.category, 'seatModelAircraft', function(res){
                        seat.url = res.destination + res.filename;
                        seatModelAircraftService.saveSeatModelAircraft(seat);
                    });
                }else{
                    if(vm.removeImage === true){
                        seatModelAircraftService.updateSeatModelAircraft(seat, seat.seatModelAircraftId);
                    }else{
                        uploadService.uploadImage(seat.image, vm.seat.category, 'seatModelAircraft', function(res){
                            seat.url = res.destination + res.filename;
                            seatModelAircraftService.updateSeatModelAircraft(seat, seat.seatModelAircraftId)

                        });
                    }
                }
            }
        }
        vm.change = function(){
            if(vm.action == 'edit'){
                if(vm.seat.category==vm.old.category&& vm.seat.name.toUpperCase()==vm.old.name.toUpperCase() &&
                    vm.removeImage){
                    vm.buttonSave = true;
                }else{
                    vm.buttonSave = false;
                }
            }
        }
    }

    function deleteSeatController(seat, seatModelAircraftService, $uibModalInstance){
        var vm = this;
        vm.seat = seat.data;
        vm.seatId = vm.seat.seatModelAircraftId;

        vm.deleteSeat = function(){
            seatModelAircraftService.deleteSeatModelAircraft(vm.seatId)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
